import * as THREE from 'three'
import { createCompanyBillboardTexture } from './createBillboardTexture.js'

function loadSvgTexture(source)
{
    return fetch(source)
        .then((response) =>
        {
            if(!response.ok)
            {
                throw new Error(`Failed to load ${source}`)
            }

            return response.text()
        })
        .then((svgText) =>
        {
            const blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' })
            const objectUrl = URL.createObjectURL(blob)

            return new Promise((resolve, reject) =>
            {
                const image = new Image()
                image.onload = () =>
                {
                    URL.revokeObjectURL(objectUrl)
                    resolve(image)
                }
                image.onerror = (error) =>
                {
                    URL.revokeObjectURL(objectUrl)
                    reject(error)
                }
                image.src = objectUrl
            })
        })
}

export function createProjectBoardFallbackTexture(label)
{
    return createCompanyBillboardTexture({
        company: label,
        title: '',
        period: '',
    })
}

export function loadBoardTexture(source, onLoad, onError, { fallbackLabel = '' } = {})
{
    const applyTexture = (image) =>
    {
        const texture = new THREE.Texture(image)
        texture.anisotropy = 4
        texture.needsUpdate = true
        onLoad(texture)
    }

    const handleError = (error) =>
    {
        if(fallbackLabel)
        {
            onLoad(createProjectBoardFallbackTexture(fallbackLabel))

            // #region agent log
            fetch('http://127.0.0.1:7823/ingest/d35b8971-5abb-4ced-aa93-3de090899b87',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'0ad91f'},body:JSON.stringify({sessionId:'0ad91f',runId:'project-data-fix',location:'loadBoardTexture.js',message:'project texture fallback used',data:{source,fallbackLabel,error:String(error)},timestamp:Date.now(),hypothesisId:'L'})}).catch(()=>{});
            // #endregion

            return
        }

        if(onError)
        {
            onError(error)
        }
    }

    if(source.toLowerCase().endsWith('.svg'))
    {
        loadSvgTexture(source)
            .then(applyTexture)
            .catch(handleError)

        return
    }

    const image = new Image()
    image.addEventListener('load', () => applyTexture(image))
    image.addEventListener('error', (error) => handleError(error))
    image.src = source
}
